import { render } from "./App.vue?vue&type=template&id=6c491eb2"
const script = {}

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_webpack@5.109.2_clean-css@5.3.3_c_12a4214092ab7aae00986ec201088498/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__